
// Theme-aware chart colors that work in both light and dark modes
export const CHART_COLORS = {
  // Light mode primary colors
  light: {
    primary: ['#dc2626', '#0ea5e9', '#10b981', '#f59e0b', '#475569'], // Professional enterprise colors
    status: {
      new: '#0ea5e9', // Professional blue
      contacted: '#475569', // Professional slate
      interview: '#f59e0b', // Professional amber
      offer: '#10b981', // Success emerald
      hired: '#10b981', // Success emerald
      rejected: '#dc2626' // Professional red
    },
    background: '#ffffff',
    grid: '#e2e8f0',
    text: '#1e293b'
  },
  // Dark mode optimized colors
  dark: {
    primary: ['#ef4444', '#0ea5e9', '#22c55e', '#fbbf24', '#64748b'], // Brighter variants for dark mode
    status: {
      new: '#3b82f6', // Brighter blue for dark mode
      contacted: '#64748b', // Neutral slate
      interview: '#fbbf24', // Brighter amber
      offer: '#22c55e', // Brighter green
      hired: '#22c55e', // Brighter green
      rejected: '#ef4444' // Brighter red
    },
    background: '#1e293b',
    grid: '#334155',
    text: '#f8fafc'
  },
  // Legacy fallback (will be deprecated)
  primary: ['#dc2626', '#0ea5e9', '#10b981', '#f59e0b', '#475569'],
  status: {
    new: '#0ea5e9',
    contacted: '#475569',
    interview: '#f59e0b',
    offer: '#10b981',
    hired: '#10b981',
    rejected: '#dc2626'
  }
};

// Helper function to get theme-appropriate colors
export const getThemeColors = (isDark: boolean = false) => {
  return isDark ? CHART_COLORS.dark : CHART_COLORS.light;
};

// CSS variable based colors for automatic theme switching
export const CSS_CHART_COLORS = {
  primary: 'hsl(var(--chart-primary))',
  secondary: 'hsl(var(--chart-secondary))',
  accent: 'hsl(var(--chart-accent))',
  warning: 'hsl(var(--chart-warning))',
  neutral: 'hsl(var(--chart-neutral))',
  background: 'hsl(var(--chart-background))',
  grid: 'hsl(var(--chart-grid))',
  text: 'hsl(var(--chart-text))'
};
